const ListManualUploads = 
  `query Query {
    manualPayloads {
      payloadUrl
    }
  }
`

const SendToManualGateway = 
  `mutation ($dataSourceId: String!, $payloadUrl: String!) {
    sendToManualGateway(input: {dataSourceId: $dataSourceId, payloadUrl: $payloadUrl}) {
      errorMessage
      job {
        id
        status
      }
    }
  }
  `

module.exports = {
  ListManualUploads,
  SendToManualGateway,
}